'use es6';

import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import { createActions, handleActions } from 'redux-actions';
import getIn from 'transmute/getIn';
export const selectedRowsNamespace = 'selectedRows';

// Actions
const SET_SELECTED_ROWS = 'SET_SELECTED_ROWS';
const CLEAR_SELECTED_ROWS = 'CLEAR_SELECTED_ROWS';
const SET_SELECTED_EVERYTHING = 'SET_SELECTED_EVERYTHING';
export const selectedRowsActions = createActions(SET_SELECTED_ROWS, CLEAR_SELECTED_ROWS, SET_SELECTED_EVERYTHING);
const {
  setSelectedRows,
  clearSelectedRows,
  setSelectedEverything
} = selectedRowsActions;

// Selectors
const selectSelectedRows = getIn([selectedRowsNamespace, 'selectedRows']);
const selectSelectedEverything = getIn([selectedRowsNamespace, 'selectedEverything']);

// Reducer
export const selectedRowsReducer = handleActions({
  [SET_SELECTED_ROWS]: (state, {
    payload: rows
  }) => {
    return state.set('selectedRows', rows);
  },
  [CLEAR_SELECTED_ROWS]: state => {
    return state.set('selectedRows', ImmutableSet()).set('selectedEverything', false);
  },
  [SET_SELECTED_EVERYTHING]: (state, {
    payload: selectedEverything
  }) => {
    return state.set('selectedEverything', selectedEverything);
  }
}, ImmutableMap({
  selectedRows: ImmutableSet(),
  selectedEverything: false
}));
export const useSelectedRows = ({
  actionableRows
}) => {
  const dispatch = useDispatch();
  const selectedRows = useSelector(selectSelectedRows);
  const selectedEverything = useSelector(selectSelectedEverything);
  const selectEverything = () => dispatch(setSelectedEverything(true));
  const selectRow = row => dispatch(setSelectedRows(selectedRows.add(row)));
  const deselectRow = row => {
    dispatch(setSelectedRows(selectedRows.delete(row)));
    dispatch(setSelectedEverything(false));
  };
  const selectAll = () => dispatch(setSelectedRows(actionableRows));
  const deselectAll = () => {
    dispatch(clearSelectedRows());
    dispatch(setSelectedEverything(false));
  };
  const selectedAll = selectedRows.equals(actionableRows) && !selectedRows.isEmpty();
  const selectAllDisabled = actionableRows.isEmpty() && selectedRows.isEmpty();
  return {
    selectedRows,
    selectRow,
    deselectRow,
    selectAll,
    deselectAll,
    selectedAll,
    selectAllDisabled,
    selectedEverything,
    selectEverything
  };
};